// Webpack Imports
import * as bootstrap from 'bootstrap';
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination, EffectFade } from 'swiper/modules';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Lenis from 'lenis';

const lenis = new Lenis();
function raf(time) {
	lenis.raf(time);
	requestAnimationFrame(raf);
}
//console.log(hideLoadingScreen())
requestAnimationFrame(raf);
lenis.on('scroll', ScrollTrigger.update);

gsap.registerPlugin(ScrollTrigger);

function updateNavigationColors(primaryColor, secondaryColor) {
	const prevSvg = document.querySelector('.custom-prev svg');
	if (prevSvg) {
		const prevRect = prevSvg.querySelector('rect');
		const prevPath = prevSvg.querySelector('path');
		if (prevRect) prevRect.setAttribute('stroke', primaryColor);
		if (prevPath) prevPath.setAttribute('fill', primaryColor);
	}

	const nextSvg = document.querySelector('.custom-next svg');
	if (nextSvg) {
		const nextRect = nextSvg.querySelector('rect');
		const nextPath = nextSvg.querySelector('path');
		if (nextRect) nextRect.setAttribute('stroke', secondaryColor);
		if (nextPath) nextPath.setAttribute('fill', secondaryColor);
	}
}

const productSwiper = new Swiper('.productSwiper', {
	modules: [EffectFade, Navigation],
	loop: true,
	speed: 800,
	effect: 'fade',

	fadeEffect: {
		crossFade: true
	},

	navigation: {
		nextEl: '.custom-next',
		prevEl: '.custom-prev'
	},

	on: {
		init: function() {
			const activeSlide = this.slides[this.activeIndex];
			if (activeSlide) {
				const primaryColor = activeSlide.getAttribute('data-primary-color') || '#ffffff';
				const secondaryColor = activeSlide.getAttribute('data-secondary-color') || '#ffffff';
				updateNavigationColors(primaryColor, secondaryColor);
			}
		},
		slideChange: function() {
			const activeSlide = this.slides[this.activeIndex];
			if (activeSlide) {
				const primaryColor = activeSlide.getAttribute('data-primary-color') || '#ffffff';
				const secondaryColor = activeSlide.getAttribute('data-secondary-color') || '#ffffff';
				updateNavigationColors(primaryColor, secondaryColor);
			}
		}
	}
});
// کلیک روی آیتم‌های نویگیشن فلِیورها
document.querySelectorAll('.js-slide-nav li').forEach(item => {
	item.addEventListener('click', function () {
		const index = this.getAttribute('data-slide');
		productSwiper.slideTo(index);
	});
});


const swiper = new Swiper('#collection-swiper', {
  modules: [Navigation, Autoplay],
  spaceBetween: 20,
  speed: 600,
  loop: false,

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  breakpoints: {
    0: {
      slidesPerView: 1.3,
      centeredSlides: true,
      initialSlide: 1, // 👈 شروع از آیتم وسط
    },
    768: {
      slidesPerView: 2,
      centeredSlides: false,
    },
    1024: {
      slidesPerView: 4,
    }
  }
});


document.addEventListener('DOMContentLoaded', function () {
    const offcanvas = document.getElementById('sweetMenu');

    offcanvas.addEventListener('show.bs.offcanvas', function () {
        document.body.classList.add('menu-open');
    });

    offcanvas.addEventListener('hidden.bs.offcanvas', function () {
        document.body.classList.remove('menu-open');
    });
});



const mm = gsap.matchMedia();

mm.add("(min-width: 992px)", () => {
	const section = document.querySelector(".scroll-slider");
	const columnsWrap = section?.querySelector(".image-columns");
	const col1 = section?.querySelector(".column-1");
	const col2 = section?.querySelector(".column-2");
	const sweetSection = document.querySelector("#Sweet-Moments");
	const horizontalWrapper = sweetSection?.querySelector(":scope > .horizontal-wrapper");
	const track = horizontalWrapper?.querySelector(".horizontal-track");

	if (!section || !columnsWrap || !col1 || !col2) return;

	let tl = null;
	let horizontalTween = null;

	const setSweetMomentsVisible = (visible) => {
		if (!sweetSection) return;
		gsap.set(sweetSection, {
			autoAlpha: visible ? 1 : 0,
			pointerEvents: visible ? "auto" : "none",
		});
	};

	const buildHorizontalScroll = () => {
		const scrollSlider = ScrollTrigger.getById("scroll-slider-pin");
		if (!scrollSlider || !track || !horizontalWrapper) return;

		horizontalTween?.scrollTrigger?.kill();
		horizontalTween?.kill();

		horizontalTween = gsap.to(track, {
			x: () => -(track.scrollWidth - window.innerWidth),
			ease: "none",
			scrollTrigger: {
				id: "sweet-moments-pin",
				trigger: horizontalWrapper,
				start: scrollSlider.end,
				end: () => `+=${track.scrollWidth}`,
				scrub: 1.5,
				pin: true,
				pinSpacing: true,
				invalidateOnRefresh: true,
			},
		});
	};

	const imageCol = columnsWrap.closest(".col-lg-6");
	const row = columnsWrap.closest(".row");
	const container = section.querySelector(".container");

	if (container) gsap.set(container, { height: "100%" });
	if (row) gsap.set(row, { height: "100%", alignItems: "stretch" });
	if (imageCol) gsap.set(imageCol, { height: "100%", display: "flex", flexDirection: "column" });
	gsap.set(columnsWrap, { overflow: "hidden", height: "100%", flex: "1 1 auto", minHeight: 0 });

	const getScrollMetrics = () => {
		const viewH = columnsWrap.clientHeight || section.clientHeight;
		const dist1 = Math.max(0, col1.scrollHeight - viewH);
		const dist2 = Math.max(0, col2.scrollHeight - viewH);
		// Pin until the taller column has revealed every image
		const scrollLength = Math.max(dist1, dist2, 1);
		return { dist1, dist2, scrollLength };
	};

	const buildScrollSlider = () => {
		tl?.scrollTrigger?.kill();
		tl?.kill();

		const { dist1, dist2, scrollLength } = getScrollMetrics();

		// column-1: last image at bottom (y = -dist1) → first image at top (y = 0)
		// column-2: first image at top (y = 0) → last image at bottom (y = -dist2)
		gsap.set(col1, { y: -dist1 });
		gsap.set(col2, { y: 0 });

		tl = gsap.timeline({
			scrollTrigger: {
				id: "scroll-slider-pin",
				trigger: section,
				start: "top top",
				end: () => `+=${getScrollMetrics().scrollLength}`,
				scrub: 1,
				pin: true,
				pinSpacing: true,
				anticipatePin: 0,
				invalidateOnRefresh: true,
				onToggle: (self) => {
					gsap.set(section, { zIndex: self.isActive ? 50 : "auto" });
					setSweetMomentsVisible(!self.isActive);
				},
			},
		});

		tl.to(col1, { y: 0, ease: "none" }, 0);
		tl.to(col2, { y: -dist2, ease: "none" }, 0);

		buildHorizontalScroll();
		ScrollTrigger.refresh();
	};

	const images = section.querySelectorAll(".image-column img");
	let readyCount = 0;

	const onImageReady = () => {
		readyCount += 1;
		if (readyCount >= images.length) {
			buildScrollSlider();
			ScrollTrigger.refresh();
		}
	};

	if (!images.length) {
		buildScrollSlider();
	} else {
		images.forEach((img) => {
			if (img.complete) onImageReady();
			else {
				img.addEventListener("load", onImageReady, { once: true });
				img.addEventListener("error", onImageReady, { once: true });
			}
		});
	}

	const onWindowLoad = () => {
		buildScrollSlider();
		ScrollTrigger.refresh();
	};
	window.addEventListener("load", onWindowLoad);

	return () => {
		window.removeEventListener("load", onWindowLoad);
		horizontalTween?.scrollTrigger?.kill();
		horizontalTween?.kill();
		horizontalTween = null;
		tl?.scrollTrigger?.kill();
		tl?.kill();
		tl = null;
		setSweetMomentsVisible(true);
	};
});


if (window.innerWidth < 768) {

  gsap.to(".row-right", {
    xPercent: -50,
    ease: "none",
    scrollTrigger: {
      trigger: ".snack-gallery",
      start: "top bottom",
      end: "bottom top",
      scrub: true
    }
  });

  gsap.to(".row-left", {
    xPercent: 50,
    ease: "none",
    scrollTrigger: {
      trigger: ".snack-gallery",
      start: "top bottom",
      end: "bottom top",
      scrub: true
    }
  });

}

const marquees = document.querySelectorAll(".marquee__inner");

marquees.forEach(marquee => {
	const totalWidth = marquee.scrollWidth / 2;


	const isLTR = marquee.classList.contains("ltr");
	const direction = isLTR ? -1 : 1;

	gsap.to(marquee, {
		x: direction * totalWidth,
		duration: 50,
		ease: "none",
		repeat: -1,
		modifiers: {
			x: gsap.utils.unitize(x => {
				return parseFloat(x) % totalWidth;
			})
		}
	});
});

const textRows = document.querySelectorAll(".text-row .marquee-content");

textRows.forEach((marquee) => {
  const parent = marquee.closest(".text-row");
  const isLTR = parent.classList.contains("ltr");
  const width = marquee.scrollWidth / 2;

  gsap.fromTo(
    marquee,
    { x: isLTR ? 0 : -width },
    {
      x: isLTR ? -width : 0,
      duration: 40,
      ease: "none",
      repeat: -1,
      modifiers: {
        x: gsap.utils.unitize((x) => parseFloat(x) % width)
      }
    }
  );
});


//horizontal-track (tablet only — desktop ≥992 is inside matchMedia above)
const isMobile = window.innerWidth < 768;
const isTablet = !isMobile && window.innerWidth < 992;
const sweetSectionTablet = document.querySelector("#Sweet-Moments");
const horizontalWrapperTablet = sweetSectionTablet?.querySelector(":scope > .horizontal-wrapper");
const trackTablet = horizontalWrapperTablet?.querySelector(".horizontal-track");

if (isTablet && trackTablet && horizontalWrapperTablet) {
	gsap.to(trackTablet, {
		x: () => -(trackTablet.scrollWidth - window.innerWidth),
		ease: "none",
		scrollTrigger: {
			trigger: horizontalWrapperTablet,
			start: "center center",
			end: () => `+=${trackTablet.scrollWidth}`,
			scrub: 1.5,
			pin: true,
			pinSpacing: true,
		},
	});
} else if (isMobile) {

  // 📱 موبایل → خاموش کردن GSAP
  ScrollTrigger.getAll().forEach(t => t.kill());

  new Swiper(".mySwiper", {
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 20,
    loop: true,
    grabCursor: true,

    effect: "coverflow",
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 120,
      modifier: 1,
      slideShadows: false,
    },
  });

}


document.addEventListener('DOMContentLoaded', function () {
    const mobileSelect = document.getElementById('mobileFaqSelect');
    if (mobileSelect) {
        mobileSelect.addEventListener('change', function () {
            const targetTabId = this.value; //
            const targetButton = document.querySelector(`.faq-topic[data-bs-target="#${targetTabId}"]`);
            if (targetButton) {
                const bsTab = new bootstrap.Tab(targetButton);
                bsTab.show();
            }
        });
    }
});